import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';

import { RedemptionCodeValidation } from '@sondermind/utilities/models-client-insurance';
import { IAPIServiceRequestOptions, IAPIFetchResponse } from '@sondermind/utilities/models-http';

import { IRedeemedInsuranceResponse } from './redeemed-insurance-response.interface';

@Injectable({
  providedIn: 'root'
})
export class RedemptionCodesHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService,
  ) {}

  fetch(code: string, opts: Partial<IAPIServiceRequestOptions> = {}): Observable<IAPIFetchResponse<RedemptionCodeValidation>> {
    const url = `${this.configurationService.env.svcBase}/billing/redemption_codes/${code}`;
    const params = this.http.generateFetchParams(opts);

    return this.http
      .get<IAPIFetchResponse<RedemptionCodeValidation>>(url, params)
      .pipe(this.http.handleHttpError(opts.error));
  }

  redeem(
    code: string,
    persona_client_id: number = undefined,
    opts: Partial<IAPIServiceRequestOptions> = {}
  ): Observable<IRedeemedInsuranceResponse> {
    const url = `${this.configurationService.env.svcBase}/billing/redemption_codes/${code}`;
    const params = this.http.generateServiceParams(opts);
    const body = {};

    if (persona_client_id != null) {
      body['persona_client_id'] = persona_client_id;
    }

    return this.http
      .put<IAPIFetchResponse<IRedeemedInsuranceResponse>>(url, body, params)
      .pipe(
        map((resp) => resp.data),
        this.http.handleHttpError(opts.error)
      );
  }
}
